// extracted by mini-css-extract-plugin
export default {"container":"LoginForm_container__Z5Bj2","submit":"LoginForm_submit__s4RDQ","resend":"LoginForm_resend__bbvqb","membershipId":"LoginForm_membershipId__nLWKt"};